let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aZk2z")).then(() => parcelRequire('jRDDZ'));